

export default {
    getProviders,
    getServices,
}

function getProviders() {
    return [
        'Estafeta',
        'Estafeta+',
        'EstafetaLTL',
        'Redpack',
        'FedEx',
        'FedEx+',
        'FedEx++',
        'DHL',
        'DHL+',
        'Sendex',
        'JTExpress',
        '99Minutos',
        'Paquetexpress',
        'Paquetexpress+',
        'Paquetexpress++',
        'Dliver',
        'BigSmart',
        'TIL',
        'Genka',
        'ExpressPL',
        'AMPM',
        'UPS',
    ]
}

function getServices() {
    return {
        Estafeta: [
            'Terrestre',
            'Express',
            'Metropolitano',
            '11:30',
            '12:30',
            '2 Dias'
        ],
        'Estafeta+': [
            'Terrestre',
            'Express',
            'Metropolitano',
            '11:30',
            '12:30',
            '2 Dias'
        ],
        EstafetaLTL: [
            'LTL'
        ],
        Redpack: [
            'Ecoexpress',
            'Express',
            'Metropolitano'
        ],
        'FedEx': [
            'Express Saver',
            'Standard Overnight'
        ],
        'FedEx+': [
            'Express Saver',
            'Standard Overnight'
        ],
        'FedEx++': [
            'Express Saver',
            'Standard Overnight'
        ],
        DHL: [
            'EXPRESS DOMESTIC',
            'ECONOMY SELECT DOMESTIC'
        ],
        'DHL+': [
            'EXPRESS DOMESTIC',
            'ECONOMY SELECT DOMESTIC'
        ],
        Sendex: [
            'REGULAR',
            'DIFERIDO',
        ],
        JTExpress: [
            'Terrestre'
        ],
        '99Minutos': [
            'NextDay',
            'CO2',
            'SameDay',
            '99minutos',
        ],
        Paquetexpress: [
            'Terrestre',
            'Express',
            'Superexpress'
        ],
        'Paquetexpress+': [
            'Terrestre'
        ],
        'Paquetexpress++': [
            'Terrestre'
        ],
        UPS: [
            'UPS Express Saver',
            'UPS Standard'
        ],
        Dliver: [
            'Terrestre'
        ],
        BigSmart: [
            'Next Day'
        ],
        TIL: [
            'Metro Express',
            'Express',
            'Terrestre'
        ],
        Genka: [
            'STANDARD',
            'EXPRESS',
        ],
        ExpressPL: [
            'Estandar',
            'Economico',
        ],
        AMPM: [
            'ESTANDAR',
            'EXPRESS',
            'DIA SIGUIENTE',
        ],
    }
}